<template>
  <div class="material-view">
    <div class="header-box">
      <div class="header-line">
        <span class="header-label">材料Id</span>
        <el-input v-model="materialId" size="small" clearable>
        </el-input>
        <span class="header-label">供应商名称</span>
        <el-select v-model="supplierId" size="small">
          <el-option v-for="item in supplierList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
      </div>
    </div>
    <el-table :data="tableData" border size="small" cell-class-name="table-cell" row-class-name="table-row" header-cell-class-name="table-header-cell">
      <el-table-column width="40px" type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.subSupplierStatisticsDTOList" border style="width: 1061px;margin-left: 42px;" size="small">
            <el-table-column prop="name" label="供应商名称" width="120px">
            </el-table-column>
            <el-table-column prop="latestPurchaseUnitPrice" label="最新采购价" align="right" width="60px">
            </el-table-column>
            <el-table-column label="预估采购价" width="80px">
              <template v-slot="scope">
                <el-input v-model="scope.row.estimatePurchaseUnitPrice" size="small" style="width: 58px;text-align: right;" @change="((val) => {onTableInputChange(val, scope.row, props.row.rawMaterialId, 'estimatePurchaseUnitPrice')})" @focus="onFocus"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="80px">
              <template v-slot="scope">
                <el-input v-model="scope.row.remark" size="small" style="width: 58px;text-align: right;" @change="((val) => {onTableInputChange(val, scope.row, props.row.rawMaterialId, 'remark')})" @focus="onFocus"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="inboundAmount" label="进货数量/进货金额" align="right" sortable width="80px">
              <template slot-scope="scope">
                {{scope.row.inboundQuantity}}<br>
                {{parseInt(scope.row.inboundAmount)}}
              </template>
            </el-table-column>
            <el-table-column label="待退货数量/待退货金额" align="right" width="80px">
              <template slot-scope="scope">
                {{scope.row.toBeReturnQuantity}}<br>
                {{parseInt(scope.row.toBeReturnAmount)}}
              </template>
            </el-table-column>
            <el-table-column label="退货中数量/退货中金额" align="right" width="80px">
              <template slot-scope="scope">
                {{scope.row.returningQuantity}}<br>
                {{parseInt(scope.row.returningAmount)}}
              </template>
            </el-table-column>
            <el-table-column label="退货失败数量/退货失败金额" align="right" width="80px">
              <template slot-scope="scope">
                {{scope.row.returnFailQuantity}}<br>
                {{parseInt(scope.row.returnFailAmount)}}
              </template>
            </el-table-column>
            <el-table-column prop="toBeReturnRate" label="待退货率" align="right" width="80px">
            </el-table-column>
            <el-table-column prop="returningRate" label="退货中比率" align="right" width="80px">
            </el-table-column>
            <el-table-column prop="returnFailRate" label="退货失败率" align="right" width="80px">
            </el-table-column>
            <el-table-column prop="returnSuccessRate" label="退货成功率" align="right" width="80px">
            </el-table-column>
            <el-table-column prop="returnRate" label="退货率" align="right" width="80px">
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="序号" width="50px">
        <template slot-scope="scope">
          {{beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="操作" width="120px">
        <template v-slot="scope">
          <router-link :to="{path:'/client/supplierMgmt/linkSupplier',
                      query:{
                        rawMaterialId: scope.row.rawMaterialId
                      }
                    }" size="small" style="color: #5893ff;font-size: 12px;">新增</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="商品" width="60px">
        <template v-slot="img">
          <el-image style="height: 40px;width: 40px;" :src="img.row.smallImageURL" fit="fill">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="rawMaterialId" label="材料Id" width="80px">
      </el-table-column>
      <el-table-column prop="averagePurchaseUnitPrice" label="库存平均采购价" width="80px" align="right">
      </el-table-column>
      <el-table-column label="进货数量/进货金额" align="right" width="80px">
        <template slot-scope="scope">
          {{scope.row.inboundQuantity}}<br>
          {{parseInt(scope.row.inboundAmount)}}
        </template>
      </el-table-column>
      <el-table-column label="待退货数量/待退货金额" align="right" width="80px">
        <template slot-scope="scope">
          {{scope.row.toBeReturnQuantity}}<br>
          {{parseInt(scope.row.toBeReturnAmount)}}
        </template>
      </el-table-column>
      <el-table-column label="退货中数量/退货中金额" align="right" width="80px">
        <template slot-scope="scope">
          {{scope.row.returningQuantity}}<br>
          {{parseInt(scope.row.returningAmount)}}
        </template>
      </el-table-column>
      <el-table-column label="退货失败数量/退货失败金额" align="right" width="80px">
        <template slot-scope="scope">
          {{scope.row.returnFailQuantity}}<br>
          {{parseInt(scope.row.returnFailAmount)}}
        </template>
      </el-table-column>
      <el-table-column prop="toBeReturnRate" label="待退货率" align="right" width="80px">
      </el-table-column>
      <el-table-column prop="returningRate" label="退货中比率" align="right" width="80px">
      </el-table-column>
      <el-table-column prop="returnFailRate" label="退货失败率" align="right" width="80px">
      </el-table-column>
      <el-table-column prop="returnSuccessRate" label="退货成功率" align="right" width="80px">
      </el-table-column>
      <el-table-column prop="returnRate" label="退货率" align="right" width="80px">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  supplierModules
} from '@r'
export default {

  data() {
    return {
      tableData: [],
      beginIndex: 0,
      pageSize: 10000,
      totalPage: 1,
      currentPage: 1,
      focusValue: '',
      supplierId: "",
      supplierList: [],
      materialId: ""
    }
  },
  activated() {
    this.listStatisticsGroupByMaterialId();
    this.getSupplierList();
  },
  methods: {
    onTableInputChange(val, row, rawMaterialId, propName) {
      this.$confirm('是否确认修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        supplierModules.editSupplierProductRelation({
          rawMaterialId: rawMaterialId,
          supplierId: row.id,
          estimatePurchaseUnitPrice: row.estimatePurchaseUnitPrice,
          remark: row.remark
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return;
          }
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
        }).catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.message ? err.message : '编辑失败'
          });
        });
      }).catch(() => {
        row[propName] = this.focusValue
        this.$message({
          type: 'info',
          message: '已取消'
        })
      });
    },
    onFocus(e) {
      this.focusValue = e.currentTarget.value
    },
    onQueryBtnClick() {
      this.listStatisticsGroupByMaterialId();
    },
    listStatisticsGroupByMaterialId() {
      supplierModules.listStatisticsGroupByMaterialId({
        rawMaterialId: this.materialId,
        supplierId: this.supplierId,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      }).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '获取列表失败'
          });
          return
        }

        this.tableData = res.ldata;
        this.currentPage = this.beginIndex / this.pageSize + 1;
        if (this.tableData.length >= this.pageSize) {
          this.tableData.pop();
          this.totalPage = this.currentPage + 1;
        }
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.message ? err.message : '未知错误'
        });
      })
    },
    getSupplierList() {
      supplierModules.list({}).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '获取供应商列表失败'
          });
          return
        }

        this.supplierList = res.ldata;
        this.supplierList.splice(0, 0, {
          id: "",
          name: "全部"
        });
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.message ? err.message : '未知错误'
        });
      })
    }
  }
}
</script>

<style lang="scss">
.material-view {
  .el-table__expanded-cell[class*="cell"] {
    padding: 0px 0px 0px 47px;
  }

  .el-table .cell,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    .el-input {
      margin-right: 0px;
      margin-left: 0px;

      .el-input__inner {
        padding-left: 2px;
        padding-right: 2px;
      }
    }
  }
}
</style>
